<template>
<div>
    <label>{{_traducao('global', 'ano')}}:</label>
    <v-select type="number" :options="listaAnos" v-model="form.ano" class="form-control" @input="$emit('buscar-ano')"></v-select>
</div>
</template>

<script>
export default {
    props: ['form'],
    data() {
        return {
            listaAnos: [2020, 2021, 2022, 2023, 2024, 2025, 2026]
        }
    }
}
</script>